import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  useGblz,
  ls,
  a,
//  BarC,
  BoxC,
  BtnC,
  GridC,
  RootC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as RootC from "./_ccmRootC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ht from './_ht';

import * as icm from './icm';
import * as ict from './ict';

import IccvFtr from './IccvFtr';

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    bHome: ht.b,
    mode: ict.mode,
    pageName?: ht.s,
  },
  oClds: ht.ls,
}) => {

const _gUserz = gs.useGblz('user');

  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`sc/lt1`),
        oClds: [

          cr.c(GridC.N, {
            key: -10,
            abtType: 'barHdrCmnz',
            boxStlz: a(`sc/gn7`),
            lineCs: [
              {
                boxStlz: a(`f/1`),
                cellCs: [
                  {
                    boxStlz: a(`f/1  fd/rsc`),
                    oClds: [
                      pz.cz.bHome != false ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'hdrHomeCmnz',
                        boxStlz: a('pl/2'),
                        bfrIconCz: {},
                        lblCz: {
                          textz: {
                            pfx: 'メニュー',
                          }
                        },
                        pslPtyz: {
                          onPress: () => {
                            if (pz.sPz) {
                              pz.sPz.set({
                                steps: [0],
                                phs: 'dpy',
                                schz: {},
                              })
                            }
                            cr.moveTo({
                              pageName: 'icvHomeS10Rz',
                            });
                          }
                        },
                      })
                      : null,
                      cr.c(TextC.N, {
                        key: -20,
                        abtType: 'hdrCmnz',
                        boxStlz: a('pl/2'),
                        textz: {
                          pfx: _gUserz.crt._31rz?._pfx ? (`施設名：` + _gUserz.crt._31rz?._pfx) : '',
                        }
                      }),
                    ],
                  },
                  {
                    boxStlz: a(`f/1 fd/ccc`),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'hdrPageNameCmnz',
                        textz: {
                          pfx: pz.cz.pageName,
                        }
                      })
                    ],
                  },
                  {
                    boxStlz: a(`f/1 fd/rec`),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'hdrCmnz',
                        boxStlz: a('pr/2'),
                        textz: {
                          pfx: _gUserz.crt._10rz?._pfx ? (`利用者名：` + _gUserz.crt._10rz?._pfx) : '',
                        }
                      }),
                      cr.c(BtnC.N, {
                        key: -20,
                        abtType: 'hdrCmnz',
                        boxStlz: a('pr/2'),
                        bfrIconCz: {
                          iconPtyz: a('icn/users'),
                        },
                        lblCz: {
                          textz: {
                            pfx: '利用者切替',
                          }
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icvLgnS20Rz',
                            })
                          }
                        }
                      }),
                      cr.c(BtnC.N, {
                        key: -30,
                        abtType: 'hdrLgtCmnz',
                        boxStlz: a('pr/2'),
                        bfrIconCz: {},
                        lblCz: {},
                        pslPtyz: {
                          onPress: icm.lgt
                        }
                      }),
                    ],
                  },
                ]
              }
            ]
          }),

          cr.c(BoxC.N, {
            key: -20,
            abtType: 'bdyCmnz',
            oClds: pz.oClds,
          }),

          cr.c(IccvFtr, {
            key: -30,
          })

        ],
      },
    })
  );
};
